<template>
  <v-container>
    <v-card class="mx-auto" elevation="0">
      <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Dedicatoria
        </v-card-title>

        <v-card-text>
          Dicen que no debes conocer a tus ídolos porque te decepcionarás, no fue el caso con el Sr. Freddy Chavier, una persona con un amplio conocimiento del baloncesto y de la historia de este deporte en Venezuela. Pero su mayor virtud eran sus ganas de ayudar y compartir sus conocimientos con los que sentíamos su misma pasión por esta disciplina. La mayor muestra de esto se refleja en su libro “La Vinotinto del Básquet” que recopila todas las actuaciones de las selecciones nacionales desde 1930 hasta la 2011 cuando lo publicó, una verdadera hazaña el poder obtener toda la información de unos años en donde la información no estaba tan a la mano como ahora. Esta página busca humildemente complementar su legado, dando a los aficionados la posibilidad de consultar toda la data de nuestra selección de manera inmediata y organizada.
        </v-card-text>

        <v-card-actions>
          

          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <div class="d-flex flex-column justify-space-between align-center">
        <!--  <v-img
        class="black-text align-self-stretch"
        height="500px"
        src="../assets/portada.webp"
            :aspect-ratio="16/9"
 
      >
    
      </v-img> -->
      </div>
      <!--       <v-card-text class="text--primary">
        <div>Estadísticas de la Selección Nacional de Mayores Masculina</div>
      </v-card-text> -->

      <!--  <v-card-actions>
       

        
      </v-card-actions> -->
    </v-card>
    <v-row justify="space-around">
      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              :aspect-ratio="16 / 9"
              :width="500"
              src="../assets/torneos.webp"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                outlined
                rounded
                block
                @click="ir_torneos()"
              >
                Torneos
              </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>

      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              src="../assets/juegos.webp"
              :aspect-ratio="16 / 9"
              :width="500"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                outlined
                rounded
                block
                @click="ir_juegos()"
              >
                Juegos
              </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              :aspect-ratio="16 / 9"
              :width="500"
              src="../assets/jugadores.webp"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                outlined
                rounded
                block
                @click="ir_jugadores()"
              >
                Jugadores
              </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>

      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              :aspect-ratio="16 / 9"
              :width="500"
              src="../assets/gamelog.webp"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                outlined
                rounded
                block
                @click="ir_game_log()"
              >
                Game Log
              </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>

      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              :aspect-ratio="16 / 9"
              :width="500"
              src="../assets/lideres.webp"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-menu top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    outlined
                    rounded
                    block
                    v-bind="attrs"
                    v-on="on"
                  >
                    Records
                  </v-btn>
                </template>
                <v-list color="white">
                  <v-list-item
                    dense
                    link
                    router
                    to="/lideres"
                    
                  >
                    <v-list-item-title>Lideres</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    router
                    to="/records_individuales"
                    
                  >
                    <v-list-item-title>Individuales</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    router
                    to="/records_equipo"
                    
                  >
                    <v-list-item-title>Equipo</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    router
                    to="/records_rivales"
                    
                  >
                    <v-list-item-title>Rivales</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    router
                    to="/records_coachs"
                  >
                    <v-list-item-title>Coachs</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>
      <v-col cols="12" lg="4">
        <v-layout align-center justify-center>
          <v-card class="mx-auto grey lighten-5" elevation="0">
            <v-img
              class="black-text align-self-stretch"
              height="270px"
              :aspect-ratio="16 / 9"
              :width="500"
              src="../assets/ncaa.webp"
            >
            </v-img>

            <v-card-text class="text--primary">
              <div></div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                outlined
                rounded
                block
                @click="ir_ncaa()"
              >
                NCAA
              </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    this.cargaritems();
  },

  data() {
    return {
      item: [],
      dialog: true,
    };
  },

  methods: {
    async cargaritems() {
      try {
       /*  const response = await axios.get("/api/tournaments");
        this.item = response.data; */
      } catch (error) {
        console.log(error);
      }
    },
    ir_juegos() {
      this.$router.push({ name: "juegos" });
    },
    ir_jugadores() {
      this.$router.push({ name: "jugadores" });
    },
    ir_game_log() {
      this.$router.push({ name: "game_log" });
    },
    ir_torneos() {
      this.$router.push({ name: "torneos" });
    },
    ir_lideres() {
      this.$router.push({ name: "lideres" });
    },
    ir_lideres_juegos() {
      this.$router.push("/records_individuales");
    },
    ir_ncaa() {
      this.$router.push("/jugadores_ncaa");
    },
  },
};
</script>